<template>
  <div class="layout-container">
    <div class="layout-header">
      <div class="header-name">
        {{ title }}
      </div>
      <div class="header-btn layout-header-btn">
        <!-- @slot 右上角按钮插槽 -->
        <slot name="header-btn"></slot>
        <el-button
          @click="handleClick('back')"
          v-if="defaultBtns && defaultBtns.back"
          >返回</el-button
        >
        <el-button
          @click="handleClick('export')"
          v-if="defaultBtns && defaultBtns.export"
          >导出</el-button
        >
        <el-button
          @click="handleClick('import ')"
          v-if="defaultBtns && defaultBtns.import"
          >导入</el-button
        >
        <el-dropdown
          trigger="click"
          @command="handleCommand"
          v-if="commands.length > 0"
        >
          <el-button>批量操作</el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="item in commands"
                :command="item.value"
                :key="item.value"
                >{{ item.label }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <el-button
          type="primary"
          @click="handleClick('add')"
          v-if="defaultBtns && defaultBtns.add"
          ><el-icon><Plus /></el-icon>新增</el-button
        >
        <el-button
          type="primary"
          @click="handleClick('save')"
          v-if="defaultBtns && defaultBtns.save"
          ><el-icon><Collection /></el-icon>保存</el-button
        >
      </div>
    </div>
    <div class="layout-content">
      <div class="layout-content-left" v-if="layoutLeft">
        <!-- @slot 当layoutLeft为true时，layout左侧插槽 -->
        <slot name="layout-left"></slot>
      </div>
      <div class="layout-content-right" :class="layoutLeft ? 'minWidth' : ''">
        <!-- @slot 默认插槽 -->
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
/**
 * The only true button.
 * @displayName Best Button
 */
import { computed, defineComponent, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  name: "sLayout",
  props: {
    /** 页面标题 */
    title: {
      type: String,
      default: "",
      required: true,
    },
    /** 页面左右布局时使用
     * @values true / false
     */
    layoutLeft: {
      type: Boolean,
      default: false,
    },
    /** 页面默认按钮
     * @values {add:true,export:true,import :true,}
     */
    defaultBtns: {
      type: Object,
      default: () => {
        return {};
      },
    },
    /** 批量操作按钮组
     * @values [{label,value}]
     */
    commands: {
      type: Array,
      default: () => [],
    },
  },

  emits: {
    /** 点击右上角按钮时触发
     * @event command
     * @param {string} type 触发按钮类型
     */
    command: null,
  },
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const pageTitle = computed(() => {
      if (
        props.title.indexOf("新增") === -1 &&
        props.title.indexOf("详情") === -1 &&
        props.title.indexOf("编辑") === -1
      ) {
        if (route.query.type === "detail") {
          return props.title + "详情";
        } else if (route.query.type === "add") {
          return props.title + "新增";
        } else if (route.query.type === "edit") {
          return props.title + "编辑";
        } else {
          return props.title;
        }
      } else {
        return props.title;
      }
    });
    const handleCommand = (command) => {
      emit("command", command);
    };
    const handleClick = (type) => {
      if (type === "back") {
        router.go(-1);
      }
      emit("command", type);
    };
    onMounted(() => {
      console.log(props.layoutLeft, "layoutLeftlayoutLeftlayoutLeftlayoutLeft");
    });
    return {
      pageTitle,
      handleCommand,
      handleClick,
    };
  },
});
</script>
<style lang="less">
.layout-container {
  width: 100%;
  height: 100%;
  //   background: #ffffff;
  //   border-radius: 4px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 16px;
  overflow-y: scroll;
  overflow-y: overlay;
  > div {
    width: 100%;

    &.layout-header {
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 13px;
      .header-name {
        font-family: PingFang SC;
        font-weight: bold;
        color: #1b293f;
        font-size: 18px;
      }
      .header-btn {
        > div {
          margin-left: 12px;
        }
        > button {
          margin-left: 12px;
        }
      }
      .refresh {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &.layout-content {
      display: flex;
      height: calc(100% - 45px);
      padding: 16px 8px;
      background: white;
      > div {
        height: 100%;
        // width: 100%;
        &.layout-content-left {
          width: 300px;
          margin-right: 15px;
          padding-right: 8px;
          position: relative;
          &::before {
            content: "";
            background-color: #f3f5f9;
            width: 10px;
            height: calc(100% + 32px);
            top: -16px;
            right: -10px;
            position: absolute;
          }
        }
        &.layout-content-right {
          width: 100%;
          &.minWidth {
            width: calc(100% - 300px);
          }
        }
      }
    }
  }
}
</style>
